module.exports = __webpack_public_path__ + "static/media/WhiteButton.3bd7b1f6.svg";